// extracted by mini-css-extract-plugin
export default {"col":"Grid_col__iAHID","collapse":"Grid_collapse__Rqa+X"};